import { render, staticRenderFns } from "./vice.vue?vue&type=template&id=3ba6920c&scoped=true"
import script from "./vice.vue?vue&type=script&lang=js"
export * from "./vice.vue?vue&type=script&lang=js"
import style0 from "./vice.vue?vue&type=style&index=0&id=3ba6920c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba6920c",
  null
  
)

export default component.exports